module.exports = __webpack_public_path__ + "img/shape-4.56d2a38a.svg";